import { Component } from '@angular/core';
import { FmntsIconsModule } from '@fmnts/components/icons';
import { I18nModule } from '@fmnts/i18n';
import { faHandHoldingSeedling } from '@fortawesome/pro-solid-svg-icons';

@Component({
  templateUrl: './self-checkout-completed.component.html',
  standalone: true,
  imports: [I18nModule, FmntsIconsModule],
})
export class SelfCheckoutCompletedComponent {
  protected readonly _iconFinished = faHandHoldingSeedling;
}
